import { DEFAULT_TOUR_OPERATOR_SET_CONFIGURATION, TourOperatorConfiguration, TourOperatorsActivationState, TourOperatorSetState } from '@gosuite/xena-admin';
import { isArray, isBoolean, isNumber, isObject, isString } from 'util';


export function mapDeprecatedTourOperatorActivationModel(deprecatedModel: any): TourOperatorsActivationState {
	if (isArray(deprecatedModel) && !!(deprecatedModel.length)) {
		const activationState: TourOperatorsActivationState = {};

		deprecatedModel.forEach(item => {
			if (
				isObject(item)
				&& isObject(item.tourOperator)
				&& isString(item.tourOperator.rawCode)
				&& !!(item.tourOperator.rawCode.length)
				&& isBoolean(item.tourOperatorActivated)
			) {
				const config: TourOperatorConfiguration = {
					enabled: item.tourOperatorActivated,
					flightMargin: {
						absolute: null,
						relative: null
					}
				};

				if (isObject(item.flightMargins) && item.flightMargins.hasOwnProperty('flightMarginAbsolute') && item.flightMargins.hasOwnProperty('flightMarginRelative')) {
					config.flightMargin.absolute = isNumber(item.flightMargins.flightMarginAbsolute) ? item.flightMargins.flightMarginAbsolute : null;
					config.flightMargin.relative = isNumber(item.flightMargins.flightMarginRelative) ? item.flightMargins.flightMarginRelative : null;
				}

				activationState[item.tourOperator.rawCode.toUpperCase()] = config;
			}
		});

		return activationState;
	}

	return null;
}

export function mapDeprecatedTourOperatorSetModel(deprecatedModel: any): TourOperatorSetState {
	if (isArray(deprecatedModel) && !!(deprecatedModel.length)) {
		const setState: TourOperatorSetState = {};

		deprecatedModel.forEach(item => {
			if (
				isObject(item)
				&& isObject(item.tourOperator)
				&& isString(item.tourOperator.rawCode)
				&& !!(item.tourOperator.rawCode.length)
				&& isBoolean(item.tourOperatorActivated)
			) {
				setState[item.tourOperator.rawCode.toUpperCase()] = {
					packagedTour: isBoolean(item.hasPackagedTour) ? item.hasPackagedTour : DEFAULT_TOUR_OPERATOR_SET_CONFIGURATION.packagedTour,
					hotel: isBoolean(item.hasHotel) ? item.hasHotel : DEFAULT_TOUR_OPERATOR_SET_CONFIGURATION.hotel,
					flight: isBoolean(item.hasFlight) ? item.hasFlight : DEFAULT_TOUR_OPERATOR_SET_CONFIGURATION.flight
				};
			}
		});

		return setState;
	}

	return null;
}



// WEBPACK FOOTER //
// ./src/app/shared/services/config/helper/xena-admin-tour-operator-config-helper.ts